import React, { useMemo } from 'react';
import classnames from 'classnames';

import { SORT_DIRECTIONS } from '../common';

import Col from './col';

import classes from '../table.module.css';

export default function Head({
  config,
  showCaret,
  sortColumn,
  sortDirection,
  isMobile,
  onColClick,
  wrapTitleOnMobile
}) {
  const data = useMemo(
    () =>
      Object.keys(config).map((name) => ({
        config: config[name],
        name,
      })),
    [config]
  );

  const onClick = (name) => () => onColClick(name, name !== sortColumn ? SORT_DIRECTIONS.ASC : '');

  return (
    <thead>
      <tr className={classnames(classes.headRow, classes.sortable, 'table-head-row')}>
        {data.map(({ config, name }, index) => {
          const { isHiddenMobile, columnName, columnNameMobile, isSortable = true } = config;

          return (
            <Col
              key={`table-head-col-${name}-${index}`}
              text={isMobile ? columnNameMobile || columnName : columnName}
              sortValue={sortColumn === name && sortDirection}
              showCaret={isSortable && showCaret}
              isHiddenMobile={isHiddenMobile}
              onClick={isSortable ? onClick(name) : undefined}
              wrapTitleOnMobile={wrapTitleOnMobile}
            />
          );
        })}
      </tr>
    </thead>
  );
}
